var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notifications/badge/large/3-digits") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications/badge/large/3-digits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Notification"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8C723",
    fillRule: "nonzero",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#F8C723",
    fillRule: "nonzero",
    cx: 30,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8C723",
    fillRule: "nonzero",
    x: 10.2,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "New",
    fontFamily: "NunitoSans-Bold, Nunito Sans",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.244,
    y: 13
  }, "New"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon_new.8ea9c5d8.svg";
export { ForwardRef as ReactComponent };